module.exports = __webpack_public_path__ + "static/media/size_hover.520b1fa5.svg";